const { registerBlockType } = wp.blocks;
const { __, sprintf } = wp.i18n;
import { InspectorControls, PanelColorSettings, InnerBlocks, BlockControls, BlockVerticalAlignmentToolbar, AlignmentToolbar, useBlockProps, useSetting, useInnerBlocksProps, store as blockEditorStore, MediaUpload } from '@wordpress/block-editor';
import { PanelBody, RangeControl, ToggleControl, SelectControl, TextControl, Button, __experimentalUseCustomUnits as useCustomUnits,  __experimentalUnitControl as UnitControl , GradientPicker, FormToggle, FocalPointPicker, __experimentalBorderBoxControl as BorderBoxControl, TabPanel, __experimentalBoxControl as BoxControl, BaseControl } from '@wordpress/components';
import { useSelect, useDispatch } from '@wordpress/data';
import classnames from 'classnames';
import deprecated from './lib/coldeprecated';
import { column as icon } from '@wordpress/icons';
import { get } from 'lodash';
import {colors} from './lib/colors';

const BlockEdit = (props) => {
	const { attributes, setAttributes, clientId } = props;	
	const { uniqueid, verticalAlignment, textAlignment, width, templateLock, allowedBlocks, margins, paddings, border, borderradius, overlayopacity, shadowColor, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, zindex,     colBgType, colBgHType, colBgColor, colBgHColor, colBgGradient, colBgHGradient, colBgImage, colBgHImage, colBgImageParallax, colBgImageSize, colBgImageRepeat, colBgImageOverlay, colBgImagePosition, colBgOverlayColor, colBgOverlayOpacity, colBgVideo, bordertopradius, borderrightradius, borderbottomradius, borderleftradius }=attributes;

	 // set unique ID
	 setAttributes({ uniqueid: clientId.slice(0, 8),}); 

	const classes = classnames( 'block-core-columns', {
			[ `is-vertically-aligned-${ verticalAlignment }` ]: verticalAlignment,
			[ `has-text-align-${ textAlignment}`]: textAlignment,
			[ `hide-desktop` ]:  hidedesktop,
			[ `hide-tablet` ]:  hidetablet,
			[ `hide-mobile` ]:  hidemobile,
			[ `animated ${durations}`]: durations,
			[ `animated ${animation}` ]: animation,
		} );

	// Normal Bg
	let containerBg = '';
	if (colBgType !== 'none' && colBgType === 'image') {
		containerBg = `url(${colBgImage})`;
	} else {
		containerBg = 'none';
	}	

	// Hover Bg
	let containerHBg = '';
	if (colBgHType !== 'none' && colBgHType === 'image') {
		containerHBg = `url(${colBgHImage})`;
	} else {
		containerHBg = 'none';
	}	

	// Background Position
	let backgroundPosition = '';
	if(colBgType === 'image' && colBgImage)
	{
		backgroundPosition =`${colBgImagePosition.x * 100}% ${ colBgImagePosition.y * 100 }%`
	}
	else
	{
		backgroundPosition = '';
	}

	// Background Size
	let backgroundSize = '';
	if(colBgType === 'image' && colBgImage)
	{
		backgroundSize = colBgImageSize;
	}
	else
	{
		backgroundSize = '';
	}

	//Image Background Attachment
	let backgroundAttachment = '';
	if(colBgType === 'image' && colBgImage && colBgImageParallax)
	{
		backgroundAttachment='fixed';
	}
	else
	{
		backgroundAttachment='scroll';
	}	
	
	//Background Image Repeat
	let backgroundRepeat = '';
	if(colBgType === 'image' && colBgImage)
	{
		backgroundRepeat = colBgImageRepeat;
	}
	else
	{
		backgroundRepeat = '';
	}
 
	const units = useCustomUnits( {
		availableUnits: useSetting( 'spacing.units' ) || [
			'%',
			'px',
			'em',
			'rem',
			'vw',
		],
	} );


	const { columnsIds, hasChildBlocks, rootClientId } = useSelect(
		( select ) => {
			const { getBlockOrder, getBlockRootClientId } =
				select( blockEditorStore );

			const rootId = getBlockRootClientId( clientId );

			return {
				hasChildBlocks: getBlockOrder( clientId ).length > 0,
				rootClientId: rootId,
				columnsIds: getBlockOrder( rootId ),
			};
		},
		[ clientId ]
	);

	const { updateBlockAttributes } = useDispatch( blockEditorStore );

	const updateAlignment = ( value ) => {
		// Update own alignment.
		setAttributes( { verticalAlignment: value } );
		// Reset parent Columns block.
		updateBlockAttributes( rootClientId, {
			verticalAlignment: null,
		} );
	};

	const widthWithUnit = Number.isFinite( width ) ? width + '%' : width;
	const blockProps = useBlockProps( {
		className: classes,
		style: widthWithUnit ? { flexBasis: widthWithUnit } : undefined,
	} );

	const columnsCount = columnsIds.length;
	const currentColumnPosition = columnsIds.indexOf( clientId ) + 1;

	const label = sprintf(
		/* translators: 1: Block label (i.e. "Block: Column"), 2: Position of the selected block, 3: Total number of sibling blocks of the same type */
		__( '%1$s (%2$d of %3$d)','spice-blocks' ),
		blockProps[ 'aria-label' ],
		currentColumnPosition,
		columnsCount
	);

	const innerBlocksProps = useInnerBlocksProps(
		{ ...blockProps, 'aria-label': label },
		{
			templateLock,
			allowedBlocks,
			renderAppender: hasChildBlocks
				? undefined
				: InnerBlocks.ButtonBlockAppender,
		}
	);

	function setColBgColor(value) {
		setAttributes({colBgColor:value});
	}
	function setColBgHColor(value) {
		setAttributes({colBgHColor:value});
	}
	function setShadowColor(value) {
		setAttributes({shadowColor:value});
	}
	function setColOverlayColor(value) {
		setAttributes({colBgOverlayColor:value});
	}

	const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
	const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
	const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
	const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;

	return (
		<>
			<style dangerouslySetInnerHTML={{
		  		__html: [
			     `#block-${clientId}{
						background-color:${colBgColor};
						background-image:${containerBg};
						margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
						padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
						border: ${border.width} ${border.style} ${border.color};
						border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
						opacity: ${overlayopacity};
						animation-delay: ${delay}ms;
						background-position: ${backgroundPosition}; 
						background-repeat: ${colBgImageRepeat};
						background-size:${backgroundSize};
						background-attachment: ${backgroundAttachment};
						background-repeat: ${backgroundRepeat};
						z-index: ${zindex};
						overflow: hidden;
						position: relative;
					}
				#block-${clientId}:hover{
						background-color:${colBgHColor};
					}
				#block-${clientId}:hover .spice-blocks-overlay{
						opacity: 1 ;
						background-color:${colBgHColor} ;
						background-image:${containerHBg} ;
					}
					`					
			    ].join('\n')
			  }}>
			</style>
			<BlockControls>
				<BlockVerticalAlignmentToolbar
					onChange={ updateAlignment }
					value={ verticalAlignment }
				/>
				<AlignmentToolbar
					value={attributes.textAlignment}
					onChange={(newalign) => setAttributes({ textAlignment: newalign })}
				/>
			</BlockControls>
			<InspectorControls>
				<PanelBody initialOpen={false} title={__('General Settings','spice-blocks')}>
					<RangeControl 
						label={__('Overlay Opacity','spice-blocks')}			    
			      		value={ overlayopacity}
	        			onChange={(newtext) => setAttributes({ overlayopacity: newtext })}
						min={0}
						step={0.01}
						max={1}
					/>
					<TextControl
			            label={__('z-index','spice-blocks')}			    
			            value={zindex}
        				onChange={(newtext) => setAttributes({ zindex: newtext })}
				    />						

					<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit'}>					
						<ToggleControl
							label={__('Hide on Desktop','spice-blocks')}
							checked={hidedesktop}
							onChange={(newval) => setAttributes({ hidedesktop: newval })}
						/>
						<ToggleControl
							label={__('Hide on Tablet','spice-blocks')}
							checked={hidetablet}
							onChange={(newval) => setAttributes({ hidetablet: newval })}
						/>
						<ToggleControl
							label={__('Hide on Mobile','spice-blocks')}
							checked={hidemobile}
							onChange={(newval) => setAttributes({ hidemobile: newval })}
						/>
					</PanelBody>

					<PanelBody initialOpen={false} title={__('Animation Effects','spice-blocks')} className={'spice-panel-edit'}>
						 <SelectControl
                            label={__('Animation','spice-block')}
                            value={ animation }
                            options={ [
                                { label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' },
                            ] }
                            onChange={ (userVal) => setAttributes({ animation: userVal }) }					  
                        />  
				        { animation != '' && (
				        	<>
						        <SelectControl
						            label={__('Durations','spice-blocks')}
						            value={ durations }
						            options={ [
						            	{ label: __('Normal','spice-blocks'), value: ' ' },
						                { label: __('Slow','spice-blocks'), value: 'slow' },
						                { label: __('Fast','spice-blocks'), value: 'fast' },
						            ] }
						            onChange={ (newtext) => setAttributes({ durations: newtext }) }					  
						        />  
					        	<TextControl
						            label={__('Delay(ms)','spice-blocks')}			    
						            value={delay}
			        				onChange={(newtext) => setAttributes({ delay: newtext })}
							    />
							</>
							)
						}
					</PanelBody>
				</PanelBody>

				<PanelBody title={__('Spacing', 'spice-blocks')} initialOpen={false} >
					<UnitControl
						label={ __( 'Width','spice-blocks' ) }
						labelPosition="edge"
						__unstableInputWidth="80px"
						value={ width || '' }
						onChange={ ( nextWidth ) => {
							nextWidth =
								0 > parseFloat( nextWidth ) ? '0' : nextWidth;
							setAttributes( { width: nextWidth } );
						} }
						units={ units }
					/>					
					<BoxControl 
						label={__('Margin','spice-blocks')}
						inputProps={{ min: -300 }}
						values={margins}
						sides={['top', 'bottom','left','right']}
						allowReset={false}
						units={[]}
						onChange={(newValue) =>
							setAttributes({
								...margins,
								margins: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>
          			<BoxControl
						values={paddings}
						label={__('Padding','spice-blocks')}
						units={[]}
						allowReset={false}
						onChange={(newValue) =>
							setAttributes({
								...paddings,
								paddings: {
									top: newValue.top,
									left: newValue.left,
									right: newValue.right,
									bottom: newValue.bottom,
								},
							})
						}
					/>
				</PanelBody> 

				<PanelBody title={__('Background', 'spice-blocks')} initialOpen={false} >
					<TabPanel
						className="my-tab-panel"
						activeClass="active-tab"
						orientation="horizontal"
						initialTabName="tab1"
						tabs={ [
							{
								name: 'tab1',
								title: 'Normal',
								className: 'active',
							},
							{
								name: 'tab2',
								title: 'Hover',
								className: 'tab-two',
							},
						] }>
						{
							( tab ) =>  (
								<div>
									{tab.name == 'tab1' && (
										<div>
											<PanelColorSettings  initialOpen={open} className='spice-block-col-bg-color' 
												colorSettings={[ 
													{
														value: colBgColor, 
														onChange: setColBgColor, 
														label: __('Background Color:','spice-blocks')
													},
												]}
											/>
											<div className="spice_block_col_flex_panel">
												<p className="spice_block_col_panel_label"> {__('Background Type', 'spice-blocks')}</p>
												<div className="spice_block_col_panel">
													
													<Button isSmall={true} isPressed={colBgType === 'image'} onClick={() => setAttributes({colBgType: 'image',})}>
														<svg width="18" height="15" viewBox="0 0 18 15">
															<path d="M16.083.263h-14.446c-.798 0-1.445.648-1.445 1.447v11.579c0 .8.646 1.447 1.445 1.447h14.446c.798 0 1.445-.648 1.445-1.447v-11.579c0-.8-.646-1.447-1.445-1.447zm-4.334 2.171c2.389 0 2.386 3.618 0 3.618-2.385 0-2.39-3.618 0-3.618zm-9.39 10.855l4.334-5.789 2.965 3.961 2.091-2.514 3.611 4.342h-13.001z"className="svg-fill" fillRule="nonzero">
															</path>
														</svg>
													</Button>
													
													<Button isSmall={true} onClick={() => setAttributes({colBgType: 'none',})}>
														<span className="dashicons dashicons-image-rotate"></span>
													</Button>
												</div>
											</div>											

											{/* Image Background */}
											{colBgType === 'image' && (
												<Fragment>
													{colBgImage ? (
														<Fragment>
															<div className="spice_block_col_preview_container">
																<div className="spice_block_col_preview_image">
																	<FocalPointPicker
																		url={colBgImage}
																		value={colBgImagePosition}
																		onChange={(focalPoint) => setAttributes({colBgImagePosition: focalPoint,})}
																	/>
																</div>
																<div className="spice_block_col_preview_actions">
																	<button onClick={() => setAttributes({ colBgImage: '',})}>
																		<span className="dashicons dashicons-trash"></span>
																	</button>
																</div>
															</div>
														</Fragment>
													) : (
														<MediaUpload
															onSelect={(media) => setAttributes({colBgImage: media.url,})}
															type="image"
															value={colBgImage}
															render={({ open }) => (
																<button className="spice_block_col_custom_upload" onClick={open}>
																	<span className="dashicons dashicons-insert"></span>
																	<span className="spice_block_col_upload_label">
																		{__('Add Image', 'spice-blocks')}
																	</span>
																</button>
															)}
														/>
													)}
													<div className="spice_block_col_flex_panel">
														<p className="spice_block_col_panel_label">
															{__('Enable Parallax','spice-blocks')}
														</p>
														<FormToggle
															checked={colBgImageParallax}
															onChange={() => setAttributes({ colBgImageParallax: !colBgImageParallax,})}
														/>
													</div>
													<SelectControl
														label={__(
															'Background Size',
															'spice-blocks'
														)}
														options={[
															{
																label: __('Default','spice-blocks'),
																value: 'initial',
															},
															{
																label: __('Cover','spice-blocks'),
																value: 'cover',
															},
															{
																label: __('Contain','spice-blocks'),
																value: 'contain',
															},
															{
																label: __( 'Auto','spice-blocks'),
																value: 'auto',
															},
														]}
														onChange={(size) => {
															setAttributes({ colBgImageSize: size });
														}}
														value={colBgImageSize}
													/>
													<SelectControl
														label={__('Background Repeat','spice-blocks')}
														options={[
															{
																label: __('No Repeat','spice-blocks'),
																value: 'no-repeat',
															},
															{
																label: __('Repeat','spice-blocks'),
																value: 'repeat',
															},
															{
																label: __('Repeat X','spice-blocks' ),
																value: 'repeat-x',
															},
															{
																label: __('Repeat Y','spice-blocks'),
																value: 'repeat-y',
															},
														]}
														onChange={(value) => {setAttributes({ colBgImageRepeat: value });}}
														value={colBgImageRepeat}
													/>
												</Fragment>
											)}											
										</div>
									)}
									{tab.name == 'tab2' && (
										<div>
											<PanelColorSettings  initialOpen={open} className='spice-block-col-bg-color' colorSettings={[ 
													{
														value: colBgHColor, 
														onChange: setColBgHColor, 
														clearable: true,
														label: __('Background Color:','spice-blocks')
													},
												]}
											/>
																					
										</div>
									)}
								</div>
							)
						}
					</TabPanel>
			  	</PanelBody>

				{( colBgType === 'image') && (
				<Fragment>
					<PanelBody title={__('Background Overlay','spice-blocks')} initialOpen={false} >
						<div className="spice_block_col_flex_panel">
							<p className="spice_block_col_panel_label">{__('Enable Overlay','spice-blocks')}</p>
							<FormToggle
								checked={colBgImageOverlay}
								onChange={() => setAttributes({ colBgImageOverlay: !colBgImageOverlay,})}
							/>
						</div>
						{colBgImageOverlay && (
						<Fragment>
							<div className="spice_block_col_flex_panel">
								<PanelColorSettings  initialOpen={open}
									className='spice-block-section-bg-overlay'
									title={ __('Overlay Color','spice-blocks') }
									colorSettings={[
										{
											value: colBgOverlayColor,
											onChange: setColOverlayColor,
											clearable: true,
											label: __('Overlay Color:','spice-blocks')
										},
									]}
								/>
							</div>
							<RangeControl
								label={__('Overlay Opacity','spice-blocks')}
								value={colBgOverlayOpacity}
								onChange={(value) =>setAttributes({colBgOverlayOpacity: value,})}
								min={0.1}
								max={1}
								step={0.01}
							/>
						</Fragment>
						)}
					</PanelBody>
				</Fragment>
				)}		
				
				<PanelBody title={__('Border Settings', 'spice-blocks')} initialOpen={false} >
					<BorderBoxControl
						colors={colors}
						label={ __( 'Border' ,'spice-blocks') }
						onChange={(newtext) => setAttributes({ border: newtext })}
						value={ border }
					/>
					<BaseControl className="spice-blocks-border-radius" label={__('Border Radius','spice-blocks')} __nextHasNoMarginBottom={ true }>
				        <UnitControl className={"border-radius-top"} onChange={ (newtext) => setAttributes({ bordertopradius: newtext }) } value={ bordertopradius } placeholder={"Top"} />

				        <UnitControl className={"border-radius-right"} onChange={ (newtext) => setAttributes({ borderrightradius: newtext }) } value={ borderrightradius } placeholder={"right"} />			        
				        
				        <UnitControl className={"border-radius-left"} onChange={ (newtext) => setAttributes({ borderleftradius: newtext }) } value={ borderleftradius } placeholder={"left"}/>

				        <UnitControl className={"border-radius-bottom"}  onChange={ (newtext) => setAttributes({ borderbottomradius: newtext }) } value={ borderbottomradius }  placeholder={"bottom"}/>	       
			        </BaseControl>
				</PanelBody>

				<PanelBody initialOpen={false} title={ __('Box Shadow','spice-blocks') } className={'spice-panel-edit'}>	
					<RangeControl 
						label={ __('Horizontal Shadow(px)','spice-blocks') }			    
					    value={ hshadow}
					    onChange={(newtext) => setAttributes({ hshadow: newtext })}
						min={0}
						max={100}
					/>
					<RangeControl 
						label={ __('Vertical Shadow(px)','spice-blocks') }			    
					    value={ vshadow}
			        	onChange={(newtext) => setAttributes({ vshadow: newtext })}
						min={0}
						max={100}
					/>	
					<RangeControl 
						label={ __('Blur Shadow(px)','spice-blocks') }			    
					    value={ blurshadow}
			        	onChange={(newtext) => setAttributes({ blurshadow: newtext })}
						min={0}
						max={100}
					/>
					<PanelColorSettings  initialOpen={true}
						className='spice-block-section-bg-color'
						title={ __('Box Shadow Color','spice-blocks') }
						colorSettings={[
							{
							value: shadowColor,
							onChange: setShadowColor,
							label: __('Box Shadow:','spice-blocks')
							},
						]}
					/>
				</PanelBody>

			</InspectorControls>
			<div { ...innerBlocksProps }>   
												
				{(colBgType === 'image' ) &&
					colBgType !== 'none' &&
					colBgImageOverlay && (
						<div className={"spice-blocks-overlay"} style={{
								backgroundColor: colBgImageOverlay
									? colBgOverlayColor
									: '',
								opacity: colBgImageOverlay ? colBgOverlayOpacity : '',
							}}>
						</div>
				)}
				<div className={"spice-column-wrapper"}>
					{ innerBlocksProps.children }
				</div>
			</div>
		</>
	);
}
 
registerBlockType('spice-blocks/spice-column', {
 apiVersion: 2,
 title: __('Column','spice-blocks'),
 category: 'spice-blocks',
 parent:['spice-blocks/spice-section'],
 icon:<svg xmlns="http://www.w3.org/2000/svg" width="24.000000000000004" height="24.000000000000004"><g><g stroke="null"><g stroke="null"><g stroke="null"><rect stroke="null" height="24" width="10.8" y="0" x="0" fill="#09A223"></rect><rect stroke="null" height="24" width="10.8" y="0" x="13" fill="#09A223"></rect></g></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g><g stroke="null"></g></g></g></svg>,
	example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
	keywords: ['Spice Column', 'column'],
	"attributes": {
		uniqueid:{
			type:'string'
		},
		mediaId: {
			type: 'number',
			default: 0
		},
		mediaUrl: {
			type: 'string',
			default: ''
		},
		textAlignment: {
			type: 'string',
			default:'center'
		},
		verticalAlignment: {
			type: 'string'
		},
		width: {
			type: 'string'
		},
		allowedBlocks: {
			type: 'array'
		},
		templateLock: {
			type: [ "string", "boolean" ],
			enum: [ "all", "insert", "contentOnly", false ]
		},
	    shadowColor:{
	    	type:'string',
	    	default:'#ADACAC'
	    }, 
		margins: {
	        default: {
	            top: '0px',	            
	            right: 'auto',
	            bottom: '0px',
	            left: 'auto',
	        }
    	},
		paddings:{
			type: 'object',
		    default: {
		        top: '0px',
		        left: '0px',
		        right: '0px',
		        bottom: '0px',
		      },
		},
		border: {
            type: 'object',
            default: {
                color: '',
                style: '',
                width: '',        
            },
        },
        bordertopradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderrightradius:{
	    	type: 'string', 
	    	default: '0px' 
	    },
	    borderbottomradius:{
	    	type: 'string',
	    	default: '0px'
	    },
	    borderleftradius:{
	    	type: 'string',
	    	default: '0px'
	    },

        overlayopacity:{
			type:'number',
		},
		zindex:{
			type:'string'
		},
		hshadow: {
			type: 'number',
			default: 0
		},
		vshadow: {
			type: 'number',
			default: 0
		},
		blurshadow: {
			type: 'number',
			default: 0
		},
		hidedesktop:{
	    	type: 'boolean',
			default: false
	    },
	    hidetablet:{
	    	type: 'boolean',
			default: false
	    },
	    hidemobile:{
	    	type: 'boolean',
			default: false
	    },
	    animation:{
	    	type:'string',
	    	default:''
	    },
	    durations:{
	    	type:'string',
	    	default:' '
	    },
	    delay:{
	    	type:'string',
	    },
		colBgType: {
			"type": "string",
			"default": "none"
		},
		colBgHType: {
			"type": "string",
			"default": "none"
		},
		colBgColor:{
			type:'string',
		},
		colBgHColor:{
			type:'string',
		},
		colBgGradient: {
			"type": "string",
			"default": "linear-gradient(135deg,#12c2e9 0%,#c471ed 50%,#f64f59 100%)"
		},
		colBgHGradient: {
			"type": "string",
			"default": "linear-gradient(135deg,#12c2e9 0%,#c471ed 50%,#f64f59 100%)"
		},
		colBgImage: {
			"type": "string"
		},
		colBgHImage: {
			"type": "string"
		},
		colBgImageParallax: {
			"type": "boolean",
			"default": false
		},
		colBgImageSize: {
			"type": "string",
			"default": "cover"
		},
		colBgImageRepeat: {
			"type": "string",
			"default": "no-repeat"
		},
		colBgImageOverlay: {
			"type": "boolean",
			"default": false
		},
		colBgOverlayColor: {
			"type": "string",
			"default": "#000000"
		},
		colBgOverlayOpacity: {
			"type": "number",
			"default": 0.6
		},
		colBgVideo: {
			"type": "string"
		},
		colBgImagePosition: {
			"type": "object",
			"default": {
				"x": 0.5,
				"y": 0.5
			}
		}

	},
	
	edit: BlockEdit,
	save: (props) => { 
		const { attributes, setAttributes,clientId } = props;
		const { uniqueid, verticalAlignment, textAlignment, width, margins, paddings, border, borderradius, overlayopacity, shadowColor, hshadow, vshadow, blurshadow, hidedesktop, hidetablet, hidemobile, animation, durations, delay, zindex, colBgType, colBgHType, colBgColor, colBgHColor, colBgImage, colBgHImage,  colBgImageParallax, colBgImageSize, colBgImageRepeat, colBgImageOverlay, colBgImagePosition, colBgOverlayColor, colBgOverlayOpacity, bordertopradius, borderrightradius, borderbottomradius, borderleftradius  } = attributes;
		
		// Normal Bg for save method
		let containerBg = '';
		if (colBgType !== 'none' && colBgType === 'image') {
			containerBg = `url(${colBgImage})`;
		} else {
			containerBg = 'none';
		}	

		// Hover Bg for save method
		let containerHBg = '';
		if (colBgHType !== 'none' && colBgHType === 'image') {
			containerHBg = `url(${colBgHImage})`;
		} else {
			containerHBg = 'none';
		}	
		
		// Background Position for save method	
		let backgroundPosition = '';
		if(colBgType === 'image' && colBgImage)
		{
			backgroundPosition =`${colBgImagePosition.x * 100}% ${ colBgImagePosition.y * 100 }%`
		}
		else
		{
			backgroundPosition = '';
		}
	
		// Background Size for save method
		let backgroundSize = '';
		if(colBgType === 'image' && colBgImage)
		{
			backgroundSize = colBgImageSize;
		}
		else
		{
			backgroundSize = '';
		}
	
		//Image Background Attachment
		let backgroundAttachment = '';
		if(colBgType === 'image' && colBgImage && colBgImageParallax)
		{
			backgroundAttachment='fixed';
		}
		else
		{
			backgroundAttachment='scroll';
		}	
		
		//Background Image Repeat
		let backgroundRepeat = '';
		if(colBgType === 'image' && colBgImage)
		{
			backgroundRepeat = colBgImageRepeat;
		}
		else
		{
			backgroundRepeat = '';
		}	

		const wrapperClasses = classnames( {
			[ `is-vertically-aligned-${ verticalAlignment }` ]: verticalAlignment,
			[ `has-text-align-${ textAlignment}`]: textAlignment,
			[ `hide-desktop` ]:  hidedesktop,
			[ `hide-tablet` ]:  hidetablet,
			[ `hide-mobile` ]:  hidemobile,
			[ `animated ${durations}`]: durations,
			[ `animated ${animation}` ]: animation,
			[ `spice-block-col-${uniqueid}` ]:  'uniqueid',
		} );

	
		let style;

		if ( width && /\d/.test( width ) ) {
			// Numbers are handled for backward compatibility as they can be still provided with templates.
			let flexBasis = Number.isFinite( width ) ? width + '%' : width;
			// In some cases we need to round the width to a shorter float.
			if ( ! Number.isFinite( width ) && width?.endsWith( '%' ) ) {
				const multiplier = 1000000000000;
				// Shrink the number back to a reasonable float.
				flexBasis =
					Math.round( Number.parseFloat( width ) * multiplier ) /
						multiplier +
					'%';
			}
			style = { flexBasis };
		}

		const blockProps = useBlockProps.save( {
			className: wrapperClasses,
			style,
		} );
		const innerBlocksProps = useInnerBlocksProps.save( blockProps );
		const widthWithUnit = Number.isFinite( width ) ? width + '%' : width;

		const bordertop=(border.top != undefined) ? `${border.top.width} ${border.top.style} ${border.top.color}` : null;
		const borderright=(border.right != undefined) ? `${border.right.width} ${border.right.style} ${border.right.color}` : null;
		const borderbottom=(border.bottom != undefined) ? `${border.bottom.width} ${border.bottom.style} ${border.bottom.color}` : null;
		const borderleft=(border.left != undefined) ? `${border.left.width} ${border.left.style} ${border.left.color}` : null;

		return(	
			<>
				<style dangerouslySetInnerHTML={{
				__html: [
					`.spice-block-col-${uniqueid}{
						background-color:${colBgColor};
						background-image:${containerBg};
						margin: ${margins.top} ${margins.right} ${margins.bottom} ${margins.left};
						padding: ${paddings.top} ${paddings.right} ${paddings.bottom} ${paddings.left};
						border: ${border.width} ${border.style} ${border.color};
						border-top:${bordertop};
						border-right:${borderright};
						border-bottom:${borderbottom};
						border-left:${borderleft};
						border-radius: ${bordertopradius} ${borderrightradius} ${borderbottomradius} ${borderleftradius};
						box-shadow: ${hshadow}px ${vshadow}px ${blurshadow}px ${shadowColor};
						opacity: ${overlayopacity};
						animation-delay: ${delay}ms;
						z-index: ${zindex};
						flex-basis:${widthWithUnit};
						background-position: ${backgroundPosition};
						background-repeat:${colBgImageRepeat};
						background-size:${backgroundSize};
						background-attachment:${backgroundAttachment};
						overflow: hidden;
						position: relative;
					}
					.spice-block-col-${uniqueid}:hover{
							background-color:${colBgHColor};
							
						}
					.spice-block-col-${uniqueid}:hover .spice-blocks-overlay{
							opacity: 1 ;
							background-color:${colBgHColor} ;
							background-image:${containerHBg} ;
						}	
						`					
					].join('\n')
				}}>
				</style>
				<div { ...innerBlocksProps }  >
					{colBgType !== 'none' && colBgType === 'video' && colBgVideo && (
						<video autoPlay={true} muted={true} loop={true} id="spice_blocks_video">
							<source src={colBgVideo} type="video/mp4" />
						</video>
					)}									
					{(colBgType === 'image' || colBgType === 'video') &&
						colBgType !== 'none' &&
						colBgImageOverlay && (
							<div className={"spice-blocks-overlay"} style={{
									backgroundColor: colBgImageOverlay
										? colBgOverlayColor
										: '',
									opacity: colBgImageOverlay ? colBgOverlayOpacity : '',
								}}>
							</div>
					)}
					<div className={"spice-column-wrapper"}>
						{ innerBlocksProps.children }
					</div>
				</div>
			</>
			);
		},
	deprecated,
});